import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function ScrumMasterSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["scrum-master"]} />;
}
